module.exports = __webpack_public_path__ + "img/nimmb.0603d39c.png";